<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
    <mat-toolbar class="example-toolbar" style="display: flex; justify-content: space-between" *ngIf="isLogged">
        <div style="display: flex">
            <div style="margin: 0px; padding: 0px; align-self: center">
                <button
                    mat-icon-button
                    mat-icon-button
                    (click)="snav?.toggle()"
                    matTooltip="{{ 'COMMONS.MENU_DESCRIPTION' | translate }}"
                    matTooltipClass="tooltip-layout"
                >
                    <div class="circleUserSmallMenu"><mat-icon>menu</mat-icon></div>
                </button>
            </div>

            <div *ngIf="!isWidthMobile" style="margin: 0px">
                <button class="toolbar-btn-login" style="margin-left: 2rem" (click)="goToHomePage()">
                    <img style="max-width: 180px; margin: 0px" src="assets/Zuc_Orizz_B_Small.png" />
                </button>
            </div>

            <div *ngIf="!isWidthMobile" style="margin: 0px; margin-top: 0.35rem; margin-left: 1.2rem">
                <h3>{{ portalName }}</h3>
            </div>

            <div *ngIf="isWidthMobile" style="margin: 0px">
                <button class="toolbar-btn-login" style="margin-left: 1.5rem" (click)="goToHomePage()">
                    <img style="max-width: 120px; margin: 0px" src="assets/Zuc_Orizz_B_Small.png" /></button
                ><br />
                <p style="margin-left: 1.5rem; margin-top: 0rem; font-size: 0.95rem; line-height: 1rem">{{ portalName }}</p>
            </div>
        </div>
        <div style="display: table; justify-content: flex-end; margin-top: 0.1rem">
            <button
                [matMenuTriggerFor]="menu2"
                style="margin-right: 1.5rem; white-space: nowrap; border: 0px; background: transparent"
                matTooltip="{{ AccountName }}"
                matTooltipClass="tooltip-layout"
            >
                <div class="circleUserSmall">{{ FullName?.trim().slice(0, 2).toLocaleUpperCase() }}</div>
            </button>
            <mat-menu #menu2="matMenu">
                <div style="display: flex; flex-direction: column; text-align: center; padding: 0.4rem; padding-bottom: 1.5rem">
                    <div class="circleUserSmall">{{ FullName?.trim().slice(0, 2).toLocaleUpperCase() }}</div>
                    <br />
                    <div style="padding: 0.2rem; padding-bottom: 0.1rem; font-size: small; font-weight: 400">
                        <span translate>COMMONS.HELLO</span>,
                    </div>
                    <div style="padding: 0.2rem; padding-bottom: 0.1rem; font-size: small">{{ FullName }}</div>
                    <div style="padding: 0.2rem; padding-bottom: 0.1rem; font-size: smaller" class="textBlack0_54">
                        {{ this.customerService?.companyInfo?.CompanyName }}
                    </div>
                </div>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="goToYourAccount()">
                    <mat-icon>account_circle</mat-icon><span translate>T_PROFILE</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="onLogoffClick()"><mat-icon>logout</mat-icon><span translate>MENU.LOGOUT</span></button>
            </mat-menu>
            <button mat-button [matMenuTriggerFor]="menu4" style="width: 3rem !important">
                <div
                    *ngIf="language === 'it-IT'"
                    fxlayout="row"
                    fxlayoutalign="center center"
                    style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center"
                >
                    <span> <img src="../../assets/icons/italy.png" class="flag mr-8" /> IT </span>
                </div>
                <div
                    *ngIf="language === 'en-US'"
                    fxlayout="row"
                    fxlayoutalign="center center"
                    style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center"
                >
                    <span> <img src="../../assets/icons/united-states.png" class="flag mr-8" /> EN </span>
                </div>
                <!-- <div
                    *ngIf="language === 'de-DE'"
                    fxlayout="row"
                    fxlayoutalign="center center"
                    style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center"
                >
                    <span> <img src="../../assets/icons/germany.png" class="flag mr-8" /> DE</span>
                </div> -->
            </button>
            <mat-menu #menu4="matMenu">
                <button mat-menu-item *ngIf="language === 'it-IT' || language === 'de-DE'" (click)="doSomething('en-US')">
                    <span
                        fxlayout="row"
                        fxlayoutalign="start center"
                        style="
                            flex-direction: row;
                            box-sizing: border-box;
                            display: flex;
                            place-content: center flex-start;
                            align-items: center;
                        "
                    >
                        <img src="../../assets/icons/united-states.png" class="flag mr-16" /><span> EN </span>
                    </span>
                </button>
                <button mat-menu-item *ngIf="language === 'en-US' || language === 'de-DE'" (click)="doSomething('it-IT')">
                    <span
                        fxlayout="row"
                        fxlayoutalign="start center"
                        style="
                            flex-direction: row;
                            box-sizing: border-box;
                            display: flex;
                            place-content: center flex-start;
                            align-items: center;
                        "
                    >
                        <img src="../../assets/icons/italy.png" class="flag mr-16" /><span> IT </span>
                    </span>
                </button>
                <!-- <button mat-menu-item *ngIf="language === 'it-IT' || language === 'en-US'" (click)="doSomething('de-DE')">
                    <span
                        fxlayout="row"
                        fxlayoutalign="start center"
                        style="
                            flex-direction: row;
                            box-sizing: border-box;
                            display: flex;
                            place-content: center flex-start;
                            align-items: center;
                        "
                    >
                        <img src="../../assets/icons/germany.png" class="flag mr-16" /><span> DE </span>
                    </span>
                </button> -->
            </mat-menu>
            <button mat-icon-button [matMenuTriggerFor]="menu3">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu3="matMenu">
                <button
                    mat-menu-item
                    *ngIf="hasAnAssociatedSubscription"
                    (click)="navigateService.goToMyMagoCloud()"
                    matTooltip="{{ 'COMMONS.GOTO_YOUR_MAGOCLOUD' | translate }}"
                    matTooltipClass="tooltip-layout"
                >
                    <mat-icon>open_in_new</mat-icon>
                    <span>MyMagoCloud</span>
                </button>
                <button
                    mat-menu-item
                    (click)="navigateService.goToMagoCloudMKT()"
                    matTooltip="{{ 'COMMONS.GOTO_MARKETING_WEBSITE' | translate }}"
                    matTooltipClass="tooltip-layout"
                >
                    <mat-icon>open_in_new</mat-icon>
                    <span>mago.cloud</span>
                </button>
            </mat-menu>
        </div>
    </mat-toolbar>
    <div style="display: flex; flex-direction: row; justify-content: space-between; padding: 1.2rem" *ngIf="!isLogged">
        <div style="display: flex; justify-content: flex-start">
            <div style="margin: 0px; padding: 0px">
                <button class="toolbar-btn-login" style="margin-left: 2rem" (click)="goToHomePage()">
                    <img style="width: 100%; margin: 0px" src="assets/Zuc_Orizz_B_Small.png" />
                </button>
            </div>
            <div style="margin: 0px; margin-top: 0.8rem; margin-left: 1rem">
                <h2>{{ portalName }}</h2>
            </div>
        </div>
        <div>
            <button mat-button [matMenuTriggerFor]="menu4" style="width: 3rem !important">
                <div
                    *ngIf="language === 'it-IT'"
                    fxlayout="row"
                    fxlayoutalign="center center"
                    style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center"
                >
                    <span> <img src="../../assets/icons/italy.png" class="flag mr-8" /> IT </span>
                </div>
                <div
                    *ngIf="language === 'en-US'"
                    fxlayout="row"
                    fxlayoutalign="center center"
                    style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center"
                >
                    <span> <img src="../../assets/icons/united-states.png" class="flag mr-8" /> EN </span>
                </div>
                <!-- <div
                    *ngIf="language === 'de-DE'"
                    fxlayout="row"
                    fxlayoutalign="center center"
                    style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center"
                >
                    <span> <img src="../../assets/icons/germany.png" class="flag mr-8" /> DE</span>
                </div> -->
            </button>
            <mat-menu #menu4="matMenu">
                <button mat-menu-item *ngIf="language === 'it-IT' || language === 'de-DE'" (click)="doSomething('en-US')">
                    <span
                        fxlayout="row"
                        fxlayoutalign="start center"
                        style="
                            flex-direction: row;
                            box-sizing: border-box;
                            display: flex;
                            place-content: center flex-start;
                            align-items: center;
                        "
                    >
                        <img src="../../assets/icons/united-states.png" class="flag mr-16" /><span> EN </span>
                    </span>
                </button>
                <button mat-menu-item *ngIf="language === 'en-US' || language === 'de-DE'" (click)="doSomething('it-IT')">
                    <span
                        fxlayout="row"
                        fxlayoutalign="start center"
                        style="
                            flex-direction: row;
                            box-sizing: border-box;
                            display: flex;
                            place-content: center flex-start;
                            align-items: center;
                        "
                    >
                        <img src="../../assets/icons/italy.png" class="flag mr-16" /><span> IT </span>
                    </span>
                </button>
                <!-- <button mat-menu-item *ngIf="language === 'it-IT' || language === 'en-US'" (click)="doSomething('de-DE')">
                    <span
                        fxlayout="row"
                        fxlayoutalign="start center"
                        style="
                            flex-direction: row;
                            box-sizing: border-box;
                            display: flex;
                            place-content: center flex-start;
                            align-items: center;
                        "
                    >
                        <img src="../../assets/icons/germany.png" class="flag mr-16" /><span> DE </span>
                    </span>
                </button> -->
            </mat-menu>
        </div>
    </div>
    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
        <mat-sidenav *ngIf="isLogged" #snav [mode]="over" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56 ">
            <mat-nav-list>
                <div class="sidenav-profile">
                    <div style="text-align: center">
                        <h3 class="accountName">{{ FullName }}</h3>
                        <h5 class="accountEmail">{{ AccountName }}</h5>
                    </div>
                    <div style="text-align: center; position: relative; top: 2.2rem; display: block">
                        <div class="circleUser">{{ FullName.trim().slice(0, 2).toLocaleUpperCase() }}</div>
                    </div>
                </div>
                <a mat-list-item class="sidenav-btn" (click)="goToDashboard()">
                    <mat-icon matListItemIcon class="material-iconsMenu">dashboard</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn">Dashboard</span>
                </a>
                <a
                    mat-list-item
                    *ngIf="this.showSubAccMenu || this.customerService.canSeeNFSSection"
                    class="sidenav-btn"
                    (click)="goToManagement()"
                >
                    <mat-icon matListItemIcon class="material-iconsMenu">miscellaneous_services</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate
                        >SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</span
                    >
                </a>
                <a
                    mat-list-item
                    *ngIf="
                        (isLogged &&
                            (this.storeRolesService?.isMagoWeb_Partner || this.storeRolesService?.isMagoCloud_Partner) &&
                            !this.storeRolesService?.isZucchettiAccount) ||
                        isDirettaLodiAccountAllowed
                    "
                    class="sidenav-btn"
                    (click)="goToMyUsers()"
                >
                    <mat-icon matListItemIcon class="material-iconsMenu">groups</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate>COMMONS.MY_CUSTOMERS</span>
                </a>

                <a
                    mat-list-item
                    *ngIf="
                        this.storeRoleService?.isReseller ||
                        this.storeRolesService?.isZucchettiAccount ||
                        this.storeRolesService?.IsInternal
                    "
                    class="sidenav-btn"
                    (click)="goToProducts()"
                >
                    <mat-icon matListItemIcon class="material-iconsMenu">download</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate>COMMONS.PRODUCTS</span>
                </a>
                <a
                  mat-list-item
                  *ngIf="(this.storeRoleService?.isReseller && this.customerService?.canSeeVerticalSolution)||
                      this.storeRoleService?.isWebSiteAdmin ||
                      this.storeRolesService?.isZucchettiAccount ||
                      this.storeRolesService?.IsInternal
                  "
                  class="sidenav-btn"
                  (click)="goToVerticalSolution()"
                  >
                  <mat-icon matListItemIcon class="material-iconsMenu">extension</mat-icon>
                  <span matListItemTitle class="sidenav-center-btn" translate>COMMONS.VERTICAL_SOLUTIONS_SECTION</span>
                </a>
                <a mat-list-item class="sidenav-btn" *ngIf="true" (click)="goToTechnicalSupport()">
                    <mat-icon matListItemIcon class="material-iconsMenu">settings</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate>COMMONS.TECHNICAL_SUPPORT</span>
                </a>
                <a mat-list-item class="sidenav-btn" *ngIf="true" (click)="goToMagoUniversity()">
                    <mat-icon matListItemIcon class="material-iconsMenu">school</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate>MENU.UNIVERSITY</span>
                </a>

                <a mat-list-item class="sidenav-btn" (click)="goToMyProfileGlobal()">
                    <mat-icon matListItemIcon class="material-iconsMenu">manage_accounts</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate>T_PROFILE</span>
                </a>
                <a *ngIf="false" mat-list-item class="sidenav-btn" (click)="goToHelpCenter()">
                    <mat-icon matListItemIcon class="material-iconsMenu">help</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate>Help center</span>
                </a>
                <a mat-list-item class="sidenav-btn" (click)="goToDocumentation()">
                    <mat-icon matListItemIcon class="material-iconsMenu">folder</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate>COMMONS.DOCUMENTATION</span>
                </a>
                <a mat-list-item *ngIf="this.storeRoleService?.IsInternal" class="sidenav-btn" (click)="goToUsoInterno()">
                    <mat-icon matListItemIcon class="material-iconsMenu">build</mat-icon>
                    <span matListItemTitle class="sidenav-center-btn" translate>COMMONS.INTERNAL_USE_SECTION</span>
                </a>

            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content>
            <div style="display: flex; height: 100%; flex-direction: column; justify-content: space-between">
                <div class="page-layout">
                    <router-outlet></router-outlet>
                </div>
                <div class="footer-layout">
                    <footer class="footerSmall">
                        <div style="display: flex; align-items: flex-end">
                            <div>
                                <div [innerHtml]="this.footercopyright"></div>
                            </div>
                            <div style="margin-left: auto; margin-top: auto">
                                <a target="_blank" href="{{ privacyLink }}">Privacy</a>&nbsp;
                                <a target="_blank" href="{{ legalNotesLink }}"><span translate>DIALOG.footerSubTitle_2</span></a>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
